import Router from 'vue-router';
import Wiki from '@/views/Wiki.vue';
import Lotto from '@/views/Lotto/Lotto.vue';
import Sport from '@/views/Sport.vue';
import Outrights from '@/views/Outrights.vue';
import LottoResults from '@/views/LottoResults.vue';
import SportResults from '@/views/SportResults.vue';
import MatchMobileResults from '@/views/MatchMobileResults.vue';
import OutrightsResults from '@/views/OutrightsResults.vue';
import Deposit from '@/views/Deposit.vue';
import Registration from '@/views/Registration.vue';
import Homepage from '@/views/Homepage.vue';
import Horses from '@/views/Horses.vue';
import HorseResults from '@/views/HorseResults.vue';
import VerifyTicket from '@/views/VerifyTicket.vue';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location)
{
    return originalPush.call(this, location).catch((err) =>
    {
        if (err.name !== 'NavigationDuplicated'
        && err.message != null && err.message.indexOf('Redirected') === -1)
        {
            throw err;
        }
    });
};

const wiki = [
    {
        path: 'wiki/:wikiname',
        component: Wiki,
        name: 'wiki',
        props: true,
        meta:
        {
            title: 'WIKI',
        },
    },
];

const base = [
    {
        path: 'verifyticket',
        component: VerifyTicket,
        name: 'verifyticket',
        meta:
        {
            title: 'VERIFYTICKET',
        },
    },
];

const homepage = [
    {
        path: '',
        component: Homepage,
        meta:
        {
            title: 'HOMEPAGE',
        },
    },
];

const sport = [
    {
        path: 'sport/:startDate?/:sportId?/:mode(favourites)?/:categoryId?/:tournamentId?',
        props: true,
        component: Sport,
        name: 'prematch',
        meta:
        {
            title: 'SPORTBETTING',
        },
    },
    {
        path: 'live/:sportId?/:mode(favourites)?/:categoryId?/:tournamentId?',
        props: true,
        component: Sport,
        name: 'live',
        meta:
        {
            title: 'LIVEBETTING',
        },
    },
    {
        path: 'results/sport/:sportState',
        component: SportResults,
        name: 'results_sport',
        props: true,
        meta:
        {
            title: 'SPORTRESULTS',
        },
    },
    {
        path: 'results/:sportState/:matchId',
        component: MatchMobileResults,
        name: 'results_match_mobile',
        props: true,
        meta:
        {
            title: 'MATCHRESULTS',
        },
    },
];

const outrights = [
    {
        path: 'outrights/:startDate?/:pathMatch?',
        component: Outrights,
        name: 'outrights',
        meta:
        {
            title: 'OUTRIGHTSBETTING',
        },
    },
    {
        path: 'results/outrights',
        component: OutrightsResults,
        name: 'results_outrights',
        meta:
        {
            title: 'OUTRIGHTSRESULTS',
        },
    },
];

const lotto = [
    {
        path: 'lotto/:lottoId?/:lottoOfferId?/',
        props: true,
        component: Lotto,
        name: 'lotto',
        meta:
        {
            title: 'LOTTOBETTING',
        },
    },
    {
        path: 'results/lotto',
        component: LottoResults,
        name: 'results_lotto',
        meta:
        {
            title: 'LOTTORESULTS',
            hasBetslip: true,
        },
    },
];

const horses = [
    {
        path: 'horses',
        component: Horses,
        name: 'horses',
        meta:
        {
            title: 'HORSESBETTING',
            hasBetslip: true,
        },
    },
    {
        path: 'results/horses',
        component: HorseResults,
        name: 'results_horses',
        meta:
        {
            title: 'HORSERESULTS',
        },
    },
];

const playerUtilities = [
    {
        path: 'deposit',
        component: Deposit,
        meta:
        {
            title: 'DEPOSIT',
        },
    },
    {
        path: 'registration',
        component: Registration,
        meta:
        {
            title: 'REGISTRATION',
        },
    },
];

export default {
    Router,
    wiki,
    base,
    homepage,
    sport,
    outrights,
    lotto,
    horses,
    playerUtilities,
};
